module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-netaly-reshef-187083-7aec77b183b18b81e6660d2f9e8e4e81.jpg";